import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const getAddressCallable = httpsCallable(functions, 'getProfileInboundAddress');
const createAddressCallable = httpsCallable(functions, 'getOrCreateProfileInboundAddress');
const getStateCallable = httpsCallable(functions, 'getProfileInboundEmailState');
const approveSenderCallable = httpsCallable(functions, 'approveProfileInboundSender');
const rejectEmailCallable = httpsCallable(functions, 'rejectProfileInboundEmail');
const removeSenderCallable = httpsCallable(functions, 'removeProfileInboundSender');
const replaceAddressCallable = httpsCallable(functions, 'replaceProfileInboundAddress');
const getDeviceTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

export const getProfileInboundEmailAddress = async (childId = '') => {
  const response = await getAddressCallable({ childId });
  return response.data || { address: '', status: 'not_configured' };
};

export const createProfileInboundEmailAddress = async (childId = '') => {
  const response = await createAddressCallable({ childId, timeZone: getDeviceTimeZone() });
  return response.data || { address: '', status: 'not_configured' };
};

export const getProfileInboundEmailState = async (childId = '') => {
  const response = await getStateCallable({ childId, timeZone: getDeviceTimeZone() });
  return response.data || { address: '', status: 'not_configured', pendingEmails: [], approvedSenders: [] };
};

export const approveProfileInboundEmailSender = async (childId = '', emailId = '') => {
  const response = await approveSenderCallable({ childId, emailId });
  return response.data || {};
};

export const rejectProfileInboundEmail = async (childId = '', emailId = '') => {
  const response = await rejectEmailCallable({ childId, emailId });
  return response.data || {};
};

export const removeProfileInboundEmailSender = async (childId = '', senderEmail = '') => {
  const response = await removeSenderCallable({ childId, senderEmail });
  return response.data || {};
};

export const replaceProfileInboundEmailAddress = async (childId = '') => {
  const response = await replaceAddressCallable({ childId, timeZone: getDeviceTimeZone() });
  return response.data || {};
};
